import Dashboard from "../../components/dashboard";
import JoinedLeagues from "../../pages/joinedLeagues";
import JoinedLeagueDetail from "../../pages/joinedLeagues/component/JoinedLeagueDetail";
import SeasonDetail from "../../pages/joinedLeagues/component/season/SeasonDetail";
import JoinedDetail from "../../pages/joinedLeagues/component/LeagueDetail";
import MyLeagues from "../../pages/my_leagues";
import LeagueByID from "../../pages/my_leagues/leagueByID";
import SeasonDetails from "../../pages/my_leagues/leagueByID/seasonDetails";
import Profile from "../../pages/profile";
import Private from "./Private";

export const Pages = {
  element: <Private />,
  children: [
    {
      element: <Dashboard />, // Wrap Dashboard with ErrorBoundary
      children: [
        {
          element: <MyLeagues />,
          path: "/my_leagues",
        },
        {
          element: <LeagueByID />,
          path: "/my_leagues/:id",
        },
        {
          element: <SeasonDetail />,
          path: "/my_leagues/:id/season/:seasonId",
        },
        {
          element: <JoinedLeagues />,
          path: "/joined_leagues",
        },
        {
          element: <JoinedDetail />,
          path: "/joined_leagues/:id",
        },
        {
          element: <JoinedLeagueDetail />,
          path: "/joined_leagues/:id",
        },
        {
          element: <SeasonDetail />,
          path: "/joined_leagues/:id/season/:seasonId",
        },
        {
          element: <Profile />,
          path: "/profile",
        },
      ],
    },
  ],
};
